import "./index.scss"

require.context("./static", false, /\.(jpg|webp)$/)
